import { styled } from "../imports";
import Box from "./Box";
import { sizeProps, overflowProps } from "../props";
import { rem } from "../utils";
var MainColumn = /*#__PURE__*/styled(Box, {
  label: "MainColumn",
  target: "css-1e94bqe0"
})("width:100%;max-width:", rem(1200), ";", sizeProps, ";", overflowProps, ";margin-left:auto;margin-right:auto;");
MainColumn.displayName = "MainColumn";
export default MainColumn;